import React, { useCallback } from "react";
import { Flex, Form, Input, message, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import {
  LoginResponseSchema,
  OTPVerifySchema,
} from "@/schemas";
import { publicRequest } from "@/services";
import { useNavigate } from "react-router-dom";

const onRequestOTPVerify = async (body: OTPVerifySchema) => {
  try {
    const result = await publicRequest<OTPVerifySchema, LoginResponseSchema>({
      url: "/verify-otp",
      method: "POST",
      data: body,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

const LoginOTPVerified: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const onOTPVerify = useCallback(() => {
    form
      .validateFields()
      .then(async () => {
        try {
          const body = {
            phone: localStorage.getItem("phone") ?? "",
            email: localStorage.getItem("email") ?? "",
            type: localStorage.getItem("otp-type") ?? "",
            otp: form.getFieldValue("otp").toString(),
          };

          const result = await onRequestOTPVerify(body);

          if (result?.data?.token) {
            await localStorage.setItem("access_token", result?.data?.token ?? "");

            console.log(result?.data.token)
            message.success("ログインしました。");

            navigate("/admin", { replace: true });
          } else if (result?.code == "401") {
            message.error("otp is expired");
          } else {
            message.error("ログインに失敗しました。 もう一度お試しください。");
          }
        } catch (error) {}
      })
      .catch(() => {
        onFinishFailed();
      });
  }, [form, navigate]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        管理機能
      </Typography.Text>

      <Typography.Text style={{ fontSize: 24 }}>ログイン</Typography.Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="otp"
          label="OTPコード"
          rules={[
            { required: true, message: "Please re-enter otp code" },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="otp"
            placeholder="Please enter otp code"
            prefix={<UserOutlined />}
          />
        </Form.Item>
      </Form>
      <Form.Item>
        <SubmitButton
          onClick={onOTPVerify}
          styles={{ width: 360 }}
          form={form}
          title={"Send OTP"}
        />
      </Form.Item>

    </Flex>
  );
};

export default LoginOTPVerified;
